import React, { memo } from 'react';
import { Table, Box, Space, Flex, Title } from '@mantine/core';
// import classes from "./ProducTable.module.css"

interface ProductTableProps {
    data?: any;
}

const TableDisposal: React.FC<ProductTableProps> = ({
    data
}) => {


    const rows =
        <Table.Tr>
            <Table.Td>{1}</Table.Td>
            <Table.Td>{data?.end_life_id}</Table.Td>
            <Table.Td>{data?.EndLife?.name}</Table.Td>
        </Table.Tr>

    return (
        <div style={{ padding: '10px' }}>
            <Box style={{ background: '#40404010' }} p={'sm'}>
                <Flex
                    gap="md"
                    justify="space-between"
                    align="center"
                    direction="row"
                    wrap="wrap"

                >
                    {/* <Title order={3}>{datalist?.data?.rows[0]?.product_name}</Title> */}
                    <Title order={3}>Disposal</Title>
                </Flex>
            </Box>
            <Space h={'md'} />
            {/* Table */}

            <Table striped verticalSpacing="md">
                {/* <Table striped className={classes.customtable}> */}
                <Table.Thead>
                    <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                        <Table.Th>S no.</Table.Th>
                        <Table.Th>Disposal Id</Table.Th>
                        <Table.Th>Disposal Name</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>{rows}</Table.Tbody>
            </Table>
            {/* {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>} */}

        </div>
    );
}

export default memo(TableDisposal);
